import { patternA, patternB } from './patterns/pattern20220403'

export default {
  patternA: patternA,
  patternB: patternB,
  //patternC:
}

/* <<< history >>>
-- 2022/04/03 リリース
basicResult
  message1
    A: './patterns/pattern20220403'
    B: './patterns/pattern20220403'





 */



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/recommend/lp/counselor/houen/testData/index.js